import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core'
import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser'

import { ZardDebounceEventManagerPlugin } from './event-manager-plugins/zard-debounce-event-manager-plugin'
import { ZardEventManagerPlugin } from './event-manager-plugins/zard-event-manager-plugin'

export function provideZard(): EnvironmentProviders {
    const eventManagerPlugins = [
        {
            provide: EVENT_MANAGER_PLUGINS,
            useClass: ZardEventManagerPlugin,
            multi: true,
        },
        {
            provide: EVENT_MANAGER_PLUGINS,
            useClass: ZardDebounceEventManagerPlugin,
            multi: true,
        },
    ]

    return makeEnvironmentProviders([...eventManagerPlugins])
}
